export var getConditionType = function getConditionType(condition, typeIndex) {
  var conditionTypeId = condition.typeId || 'string';
  return typeIndex[conditionTypeId];
};